import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TrackingScreenNamesEnum } from '../../../tracking/tracking.data';
import { I2gNgTrackingActionBuilder } from 'i2g-ng-tracking';
import { IRouter } from 'i2g-ng-ui';

@Injectable()
export class SetPasswordInvalidTokenBuilder {
  constructor(
    private _translateService: TranslateService,
    private _trackingActionBuilder: I2gNgTrackingActionBuilder
  ) {}

  buildForgotPasswordRoute(): IRouter {
    return {
      label: this._translateService.instant('ACTION.SEND_ANOTHER_PASSWORD'),
      route: ['/forgot-password'],
      trackingAction: this._trackingActionBuilder.buildButtonTapped(
        'forgot_password',
        TrackingScreenNamesEnum.set_password_failed
      ),
    };
  }
}
